import axios from 'axios';

// export const redirectENV = 'https://appuat.odynn.com';
// export const redirectENV = 'https://awayzdev.odynn.com';
export const redirectENV = 'https://awayz.odynn.com';

// export const baseURL = 'https://appuat.odynn.info:3000'; //UAT
// export const baseURL = 'https://appdev.odynn.info:3000'; //DEV
export const baseURL = 'https://app.odynn.info:3000'; //PROD
// export const baseURL = 'http://localhost:3000'; //LOCAL

const api = axios.create({
  baseURL: baseURL
});

export default api;
